function splitCategoryNames(categoryNames) {
  return (categoryNames || '')
    .split(/[、,，/]/)
    .map((item) => item.trim())
    .filter(Boolean)
}

export function normalizeSchemeCustomerItem(row) {
  if (!row) return null

  const tags = splitCategoryNames(row.categoryNames)
  const viewNum = Number(row.viewNum) || 0
  const score = Math.min(98, 80 + Math.min(viewNum, 9) * 2)

  return {
    id: row.id || '',
    name: row.name || '',
    company: '',
    role: '',
    area: '',
    industry: row.categoryNames || '',
    mobilePhone: row.mobilePhone || '',
    score,
    type: row.type || '',
    viewNum,
    lastDate: row.lastDate || '',
    tags: tags.length ? tags : ['待分类'],
    reason: row.categoryNames
      ? `匹配行业：${row.categoryNames}`
      : '待后端补充推荐原因',
    action: viewNum
      ? `累计浏览/对接 ${viewNum} 次`
      : '暂无浏览/对接记录',
    raw: row
  }
}

export function normalizeSchemeKeyCustomerItem(row) {
  if (!row) return null

  // 行业标签：优先用后端 List<String> industryLabels，其次用 industry 字符串切分
  const industryTags = row.industryLabels && row.industryLabels.length
    ? row.industryLabels
    : splitCategoryNames(row.industry)

  return {
    id: row.id || row.requirementId || '',
    companyName: row.companyName || '',
    industry: industryTags.length ? industryTags : (row.industry ? [row.industry] : []),
    contactName: row.contactName || row.name || '',
    contactPhone: row.contactPhone || row.mobilePhone || row.linkPhone || '',
    requirementDesc: row.requirementDesc || row.description || '',
    recommenderName: row.recommender || row.recommenderName || '',
    pushTime: row.pushTime || row.lastDate || row.createTime || '',
    status: row.status || 'NEW_PUSH',
    statusLabel: row.statusLabel || '',
    statusType: row.statusType || '',
    pushNote: row.remark || row.pushNote || row.note || '',
    companyIntro: row.companyIntro || row.companyDesc || '',
    receiverName: row.receiverName || row.contactName || row.name || '',
    mobilePhone: row.mobilePhone || row.contactPhone || row.linkPhone || '',
    raw: row
  }
}
